import _ from 'lodash';
import { FETCH_NEXT_CLIPS_PAGE, SET_FETCHING_STATUS, SET_NEXT_CLIPS_PAGE } from './ClipsActions';

const INITIAL_STATE = {
  nextPage: null,
  paginationItems: [],
  hasMoreItems: null,
  fetching: false,
};

export default function(state = INITIAL_STATE, action) {
  const nextPage = _.get(action, 'payload.data.view.next', false);
  const newPage = _.get(action, 'payload.data.member', false);
  const { paginationItems: oldPaginationItems } = state;
  let newPaginationItems = oldPaginationItems || [];

  switch (action.type) {
    case SET_NEXT_CLIPS_PAGE:
      return {
        ...state,
        ...INITIAL_STATE,
        nextPage: action.payload,
      };
    case SET_FETCHING_STATUS:
      return {
        ...state,
        fetching: action.payload,
      };
    case FETCH_NEXT_CLIPS_PAGE:
      if (!newPage)
        return {
          ...state,
          fetching: false,
        };
      newPaginationItems = newPaginationItems.concat([...newPage]);
      return {
        ...state,
        nextPage,
        hasMoreItems: !!nextPage,
        paginationItems: [...newPaginationItems],
        fetching: false,
      };
    default:
      return state;
  }
}
